import { _ as _objectSpread2, f as _defineProperty, d as defineColors } from '../../dist/slicedToArray-1793c995.esm.js';
import { c as components$2 } from '../../dist/index-14b77795.esm.js';
import { textSizes, motion } from '@hover/blueprint-theme';
import { d as disabledSelector, f as focusSelector, h as hoverSelector, a as activeSelector, s as sizes$3 } from '../../dist/text-1fc26d72.esm.js';
import { mapValues } from '@hover/utilities';
import 'ramda/src/values';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/map';
import 'ramda/src/mergeDeepWith';
import { cssVar } from '@chakra-ui/theme-tools';
import { t as transition, s as sizes$2, v as variables } from '../../dist/transitions-5bae2ff9.esm.js';
import '@hover/tokens-typography';
import _mergeDeepRight from 'ramda/src/mergeDeepRight';
import { cssVar as cssVar$1, calc } from '@chakra-ui/react';
import { iconSizes, colorTokens, colors as colors$1, headingAliases, headingSizes, textAliases, textSizes as textSizes$1, headingPresets, headingCapsizes, textCapsizes, typography as typography$1, radii, shadows } from '@hover/blueprint-theme/bauhaus';
import * as tokens from '@hover/tokens-typography/bauhaus';
import 'polished';
import { s as space } from '../../dist/space-897bc55c.esm.js';
import { d as defineTextStyles } from '../../dist/textStyles-938e4c56.esm.js';
import '@hover/blueprint-theme/next';
import 'ramda/src/max';
import 'ramda/src/reduce';
import '../../dist/toConsumableArray-dba89f3e.esm.js';

// button is wrapper around headingContent and icon
// container is the AccordionItem
// panel is content inside AccordionItem
var Accordion = {
  parts: ['button', 'container', 'panel'],
  baseStyle: {
    button: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({
      backgroundColor: 'transparent',
      border: 'none',
      fontWeight: 700,
      padding: 0
    }, textSizes[500]), {}, {
      _focusVisible: {
        outlineColor: 'neutral.900',
        outlineStyle: 'solid',
        outlineWidth: '400'
      }
    }),
    container: {
      boxSizing: 'border-box',
      paddingY: '600'
    },
    panel: /*#__PURE__*/_objectSpread2({
      fontFamily: 'body',
      fontWeight: 'body',
      padding: 0
    }, textSizes[500])
  },
  sizes: {},
  variants: {},
  defaultProps: {}
};

var lineHeight = textSizes[300].lineHeight;
var fontSize = textSizes[300].fontSize;
var colorSchemeColors = function colorSchemeColors(colorScheme) {
  switch (colorScheme) {
    case 'success':
      return {
        backgroundColor: 'success.600',
        color: 'neutral.0'
      };
    case 'warning':
      return {
        backgroundColor: 'brandOrange600',
        color: 'neutral.0'
      };
    case 'danger':
      return {
        backgroundColor: 'danger.600',
        color: 'neutral.0'
      };
    case 'info':
      return {
        backgroundColor: 'primary.600',
        color: 'neutral.0'
      };
    default:
      return undefined;
  }
};
var Badge = {
  defaultProps: {
    colorScheme: 'neutral',
    variant: 'primary'
  },
  baseStyle: {
    lineHeight: lineHeight,
    fontSize: fontSize,
    borderRadius: 200,
    boxSizing: 'border-box',
    fontFamily: 'body',
    fontWeight: '700',
    overflow: 'hidden',
    paddingX: 200,
    paddingY: 100
  },
  sizes: {},
  variants: {
    primary: function primary(_ref) {
      var colorScheme = _ref.colorScheme;
      var schemeColors = colorSchemeColors(colorScheme);
      if (schemeColors) {
        return schemeColors;
      }
      return {
        backgroundColor: 'neutral.900',
        color: 'neutral.0',
        _dark: {
          backgroundColor: 'neutral.0',
          color: 'neutral.900'
        }
      };
    },
    secondary: function secondary(_ref2) {
      var colorScheme = _ref2.colorScheme;
      var schemeColors = colorSchemeColors(colorScheme);
      if (schemeColors) {
        return schemeColors;
      }
      return {
        backgroundColor: 'neutral.50',
        color: 'neutral.900',
        _dark: {
          backgroundColor: 'neutral.875',
          color: 'neutral.0'
        }
      };
    },
    glass: function glass(_ref3) {
      var colorScheme = _ref3.colorScheme,
        colors = _ref3.theme.colors;
      var schemeColors = colorSchemeColors(colorScheme);
      if (schemeColors) {
        return schemeColors;
      }
      return {
        backgroundColor: colors.alpha(0.4, 'neutral.50'),
        color: 'neutral.900',
        backdropFilter: 'blur(25px)',
        _dark: {
          backgroundColor: colors.alpha(0.4, 'neutral.700'),
          color: 'neutral.0'
        }
      };
    },
    solid: {},
    brand: {}
  }
};

var sizes$1 = {
  small: {
    textStyle: 'bodySmall',
    'div > span, button > span': {
      textStyle: 'bodySmallWithCapsize'
    },
    height: '350',
    px: '300'
  },
  medium: {
    textStyle: 'bodySmall',
    'div > span, button > span': {
      textStyle: 'bodySmallWithCapsize'
    },
    height: '400',
    px: '500'
  },
  large: {
    textStyle: 'body500',
    'div > span, button > span': {
      textStyle: 'body500WithCapsize'
    },
    height: '500',
    px: '600'
  }
};
var Button = {
  baseStyle: function baseStyle(_ref) {
    var colors = _ref.theme.colors;
    return _objectSpread2(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      alignItems: 'center',
      borderColor: 'neutral.300',
      borderRadius: 'round',
      borderStyle: 'solid',
      borderWidth: '400',
      boxSizing: 'border-box',
      color: 'neutral.900',
      cursor: 'pointer',
      fontFamily: 'body',
      fontWeight: '500',
      gap: '100',
      textDecoration: 'none'
    }, disabledSelector, {
      cursor: 'default',
      color: 'neutral.400',
      borderColor: 'transparent',
      _dark: {
        color: 'neutral.500'
      }
    }), focusSelector, {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'neutral.900',
      outlineOffset: '2px'
    }), "_dark", _defineProperty({
      color: 'neutral.0'
    }, focusSelector, {
      outlineColor: 'neutral.0'
    })), '&[data-checkbox], &[data-radio]', {
      _dark: {
        borderColor: 'neutral.600'
      },
      _checked: {
        shadow: "inset 0 0 0 1px ".concat(colors.neutral900),
        borderColor: 'neutral.900',
        _dark: {
          shadow: "inset 0 0 0 1px ".concat(colors.neutral0),
          borderColor: 'neutral.0'
        }
      }
    }), transition.easing250('color', 'background', 'border', 'outline-color'));
  },
  variants: {
    primary: function primary(_ref2) {
      var colorScheme = _ref2.colorScheme,
        colors = _ref2.theme.colors;
      if (colorScheme === 'danger') {
        return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
          backgroundColor: 'danger.600',
          borderColor: 'danger.600',
          color: 'neutral.0'
        }, hoverSelector, {
          backgroundColor: colors.alpha(0.28, 'danger.600')
        }), activeSelector, {
          backgroundColor: colors.alpha(0.12, 'danger.600')
        }), disabledSelector, {
          backgroundColor: 'neutral.200'
        }), focusSelector, {
          outlineColor: 'danger.600'
        }), "_dark", _defineProperty({}, focusSelector, {
          outlineColor: 'danger.600'
        }));
      }
      return _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        backgroundColor: 'neutral.900',
        borderColor: 'transparent',
        color: 'neutral.0'
      }, hoverSelector, {
        backgroundColor: colors.alpha(0.28, 'neutral.900')
      }), activeSelector, {
        backgroundColor: colors.alpha(0.12, 'neutral.900')
      }), disabledSelector, {
        backgroundColor: 'neutral.200'
      }), "_dark", _defineProperty(_defineProperty(_defineProperty({
        backgroundColor: 'neutral.0',
        color: 'neutral.900'
      }, hoverSelector, {
        backgroundColor: colors.alpha(0.28, 'neutral.0')
      }), activeSelector, {
        backgroundColor: colors.alpha(0.12, 'neutral.0')
      }), disabledSelector, {
        color: 'neutral.500',
        backgroundColor: 'neutral.700'
      }));
    },
    secondary: function secondary(_ref5) {
      var colors = _ref5.theme.colors;
      return _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        background: 'transparent',
        color: 'neutral.900',
        borderColor: 'neutral.300'
      }, hoverSelector, {
        background: 'transparent',
        borderColor: 'neutral.900'
      }), activeSelector, {
        color: colors.alpha(0.28, 'neutral.900')
      }), disabledSelector, {
        borderColor: 'neutral.200'
      }), "_dark", _defineProperty(_defineProperty(_defineProperty({
        color: 'neutral.0',
        borderColor: 'neutral.600'
      }, hoverSelector, {
        borderColor: 'neutral.0'
      }), activeSelector, {
        color: 'neutral.0'
      }), disabledSelector, {
        borderColor: 'transparent'
      }));
    },
    glass: function glass(_ref7) {
      var colors = _ref7.theme.colors;
      return _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        background: colors.alpha(0.52, 'neutral.100'),
        borderColor: 'transparent',
        backdropFilter: 'blur(25px)'
      }, hoverSelector, {
        borderColor: 'neutral.200'
      }), activeSelector, {
        borderColor: 'neutral.200',
        color: colors.alpha(0.12, 'neutral.900')
      }), "_dark", _defineProperty(_defineProperty({
        background: colors.alpha(0.52, 'neutral.700')
      }, activeSelector, {
        color: colors.alpha(0.12, 'neutral.0')
      }), hoverSelector, {
        borderColor: colors.alpha(0.28, 'neutral.0')
      })), '&[data-checkbox], &[data-radio]', {
        _checked: _defineProperty(_defineProperty({}, hoverSelector, {
          borderColor: 'neutral.900'
        }), activeSelector, {
          borderColor: 'neutral.900'
        })
      });
    },
    ghost: function ghost(_ref9) {
      var colors = _ref9.theme.colors;
      return _defineProperty(_defineProperty(_defineProperty({
        background: 'transparent',
        borderColor: 'transparent'
      }, hoverSelector, {
        backgroundColor: colors.alpha(0.52, 'neutral.100')
      }), activeSelector, {
        color: colors.alpha(0.28, 'neutral.900')
      }), "_dark", _defineProperty(_defineProperty({}, hoverSelector, {
        backgroundColor: colors.alpha(0.52, 'neutral.700')
      }), activeSelector, {
        color: 'neutral.0'
      }));
    },
    tertiary: {
      _dark: {
        color: 'neutral.900'
      }
    }
  },
  sizes: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, sizes$1), {}, {
    // For backwards compatability with previous theme
    "default": sizes$1.medium
  }),
  defaultProps: {
    colorScheme: 'neutral',
    size: 'medium',
    variant: 'primary'
  }
};

var CloseButton = {
  defaultProps: {
    size: 'default',
    variant: 'solid'
  },
  baseStyle: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({
    border: 'none',
    borderRadius: '300',
    cursor: 'pointer',
    outline: 'none',
    // TODO(tokens/next): move to tokens
    shadow: 'inset 0 0 0 3px transparent'
  }, /*#__PURE__*/transition.easing250('background-color', 'box-shadow')), {}, {
    svg: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/transition.easing250('color')), {}, {
      color: 'neutral.900',
      strokeLinecap: 'none',
      strokeWidth: '2'
    }),
    _focusVisible: {
      outline: 'none',
      // TODO(tokens/next): move to tokens
      shadow: 'inset 0 0 0 3px var(--hover-colors-darkAlpha-200)'
    },
    _hover: {
      bg: 'darkAlpha.100'
    }
  }),
  sizes: {
    small: {
      width: '20px',
      height: '20px',
      svg: {
        width: '50',
        height: '50'
      }
    },
    "default": {
      width: '300',
      height: '300',
      svg: {
        width: '75',
        height: '75'
      }
    },
    large: {
      width: '300',
      height: '300',
      svg: {
        width: '75',
        height: '75'
      }
    }
  },
  variants: {
    minimal: {
      bg: 'transparent',
      _hover: {}
    },
    solid: {},
    soft: {}
  }
};

var $paddingLeft = /*#__PURE__*/cssVar('form-helper-text-padding-left');
var helperTextSizes = {
  "default": /*#__PURE__*/_defineProperty({}, $paddingLeft.variable, 'space.400'),
  small: /*#__PURE__*/_defineProperty({}, $paddingLeft.variable, 'space.300'),
  tiny: /*#__PURE__*/_defineProperty({}, $paddingLeft.variable, 'space.200')
};
var internalLabelHelperText = {
  paddingLeft: $paddingLeft.reference
};

var Form = {
  parts: ['container', 'helperText', 'requiredIndicator'],
  defaultProps: {
    size: 'default'
  },
  baseStyle: {
    container: {
      // Reset for when we render a `fieldset`
      border: 'none',
      margin: 0,
      padding: 0
    },
    helperText: {
      textStyle: 'body300',
      fontFamily: 'body',
      fontWeight: 'body',
      color: 'neutral.500',
      transform: 'translateY(0.4em)'
    },
    requiredIndicator: /*#__PURE__*/_objectSpread2({
      fontSize: '200',
      fontFamily: 'body',
      fontWeight: 'body',
      lineHeight: 'inherit',
      color: 'neutral.550',
      marginLeft: '0.25em'
    }, /*#__PURE__*/transition.easing250('color'))
  },
  sizes: /*#__PURE__*/_mergeDeepRight( /*#__PURE__*/mapValues(helperTextSizes, function (styles) {
    return {
      helperText: styles
    };
  }), {
    small: {
      requiredIndicator: {
        fontSize: '100'
      }
    },
    tiny: {
      helperText: {
        textStyle: 'body200'
      },
      requiredIndicator: {
        fontSize: '100'
      }
    }
  }),
  variants: {
    "default": {
      text: {
        paddingLeft: 50
      }
    },
    'internal-label': {
      helperText: internalLabelHelperText
    }
  }
};

var FormError = {
  parts: ['text'],
  defaultProps: {
    size: 'default'
  },
  baseStyle: {
    text: {
      textStyle: 'body300',
      color: 'danger.base',
      fontFamily: 'body',
      fontWeight: 'body',
      '& > span': {
        textStyle: 'body300WithCapsize'
      }
    }
  },
  sizes: /*#__PURE__*/_mergeDeepRight( /*#__PURE__*/mapValues(helperTextSizes, function (styles) {
    return {
      text: styles
    };
  }), {
    tiny: {
      text: {
        textStyle: 'body200',
        '& > span': {
          textStyle: 'body200WithCapsize'
        }
      }
    }
  }),
  variants: {
    "default": {
      text: {
        paddingLeft: 50
      }
    },
    'internal-label': {
      text: internalLabelHelperText
    }
  }
};

// NOTE: all of these variables are used specifically for the `internal-label`
// variant of `Field` when it wraps either a `TextInput` or `Select` to control
// the positioning and animation of the internal label
var $labelFontSize = /*#__PURE__*/cssVar$1('form-label-font-size');
var $labelLineHeight = /*#__PURE__*/cssVar$1('form-label-line-height');
var $labelLeft = /*#__PURE__*/cssVar$1('form-label-left');
var $focusLabelTop = /*#__PURE__*/cssVar$1('form-label-focus-top');
var $focusLabelLeft = /*#__PURE__*/cssVar$1('form-label-focus-left');
var FormLabel = {
  defaultProps: {
    size: 'default',
    variant: 'default'
  },
  baseStyle: /*#__PURE__*/_objectSpread2({
    paddingLeft: 0,
    textStyle: 'body300WithCapsize',
    fontFamily: 'body',
    color: 'neutral.600',
    marginBottom: '100'
  }, /*#__PURE__*/transition.easing250('color')),
  sizes: {
    "default": /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty({}, $labelFontSize.variable, 'fontSizes.300'), $labelLineHeight.variable, 'lineHeights.300'), $labelLeft.variable, 'space.700'), $focusLabelLeft.variable, 'space.400'), $focusLabelTop.variable, 'space.400'),
    small: /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty({}, $labelFontSize.variable, 'fontSizes.300'), $labelLineHeight.variable, 'lineHeights.300'), $labelLeft.variable, 'space.600'), $focusLabelLeft.variable, 'space.300'), $focusLabelTop.variable, 'space.200'), "textStyle", 'body200WithCapsize'),
    tiny: /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty({}, $labelFontSize.variable, 'fontSizes.200'), $labelLineHeight.variable, 'lineHeights.200'), $labelLeft.variable, 'space.500'), $focusLabelLeft.variable, 'space.200'), $focusLabelTop.variable, 'space.100'), "textStyle", 'body200WithCapsize')
  },
  variants: {
    "default": {
      // Disable Capsize unless the label is rendered internally
      _before: {
        display: 'none'
      },
      _after: {
        display: 'none'
      }
    },
    'internal-label': {}
  }
};

var Icon = {
  baseStyle: {
    display: 'block'
  },
  defaultProps: {
    size: 'small'
  },
  sizes: iconSizes,
  variants: {}
};

// For backward compatibility with legacy Blueprint color theme structure
// (e.g: `colors.primary500` instead of Chakra-style `colors.primary[500]`)
var legacyColors = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, colorTokens), {}, {
  neutral000: colorTokens.neutral0
});
var colors = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, /*#__PURE__*/defineColors(colors$1)), legacyColors), {}, {
  text: colors$1.text,
  stroke: colors$1.stroke,
  divider: colors$1.divider,
  interactive: colors$1.interactive,
  info: colors$1.info
});

var textStyles = /*#__PURE__*/defineTextStyles({
  headingAliases: headingAliases,
  headingSizes: headingSizes,
  textAliases: textAliases,
  textSizes: textSizes$1,
  headingPresets: headingPresets,
  headingCapsizes: headingCapsizes,
  textCapsizes: textCapsizes
});

var typography = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, typography$1), {}, {
  fonts: {
    heading: tokens.familyBrand,
    body: tokens.familyBody,
    mono: tokens.familyCode
  }
});

/**
 * Combined foundations object for use in `extendTheme`
 *
 * @example
 * import { extendTheme } from '@chakra-ui/react';
 * import { foundations } from '.';
 *
 * ```ts
 * const theme = extendTheme({ ...foundations });
 * ```
 */
var foundations = /*#__PURE__*/_objectSpread2({
  colors: colors,
  motion: motion,
  radii: radii,
  shadows: shadows,
  sizes: sizes$2,
  space: space,
  textStyles: textStyles,
  transition: transition
}, typography);

var $labelOffset = /*#__PURE__*/cssVar$1('input-label-offset');

/**
 * Common sizes for input fields like `TextInput` and `Select`.
 *
 * @remarks We need to use explicit height values here, which is why we're using
 * variables for `height` instead of a token name (e.g: '400') because Chakra
 * applies the raw value to the `width` of left/right input elements and the
 * padding of the input to offset the elements.
 *
 * However, our `Field` component now applies data attributes when an icon is
 * present before or after the input. In that case, we're applying custom
 * dimensions and padding to the input elements for the icons. We're preserving
 * the explicit height in case there's a need to use a custom `InputGroup` with
 * elements before or after an input.
 *
 * The `.placeholder` selector targets the faux placeholder we render in
 * `Select`
 *
 * @todo Once we upgrade Chakra, we'll be able to target the `group` parent
 * element of the `InputGroup` which will allow us to apply CSS variables there
 * instead of repeating them for the separate theme parts
 */
var sizes = {
  "default": {
    element: /*#__PURE__*/_defineProperty({
      '&.icon': {
        width: '350'
      },
      '&.element-before': {
        pl: '200'
      },
      '&.element-after': {
        pr: '200'
      }
    }, $labelOffset.variable, 'space.400'),
    field: /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty({
      borderRadius: '300',
      height: /*#__PURE__*/variables.size(500).reference,
      textStyle: 'body500WithCapsize',
      '[data-icon-before] &, [data-icon-before] & ~ .placeholder': {
        pl: '700'
      },
      '[data-icon-after] &, [data-icon-after] & ~ .placeholder': {
        pr: '700'
      },
      paddingX: '400'
    }, $labelOffset.variable, 'space.400'), '& ~ .placeholder', /*#__PURE__*/_defineProperty({
      paddingX: '400'
    }, $labelOffset.variable, 'space.400'))
  },
  small: {
    element: /*#__PURE__*/_defineProperty({
      '&.icon': {
        width: '300'
      },
      '&.element-before': {
        pl: '100'
      },
      '&.element-after': {
        pr: '100'
      }
    }, $labelOffset.variable, 'space.300'),
    field: /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty({
      borderRadius: '300',
      height: /*#__PURE__*/variables.size(400).reference,
      textStyle: 'body500WithCapsize',
      '[data-icon-before] &': {
        pl: '600'
      },
      '[data-icon-after] &': {
        pr: '600'
      }
    }, $labelOffset.variable, 'space.300'), "paddingX", '300'), '& ~ .placeholder', /*#__PURE__*/_defineProperty({
      paddingX: '300'
    }, $labelOffset.variable, 'space.300'))
  },
  tiny: {
    element: /*#__PURE__*/_defineProperty({
      '&.icon': {
        width: '200'
      },
      '&.icon-before': {
        pl: '50'
      },
      '&.icon-after': {
        pr: '50'
      },
      '&.element-before': {
        pl: '50'
      },
      '&.element-after': {
        pr: '50'
      }
    }, $labelOffset.variable, 'space.200'),
    field: {
      outlineOffset: '0px',
      borderRadius: '200',
      height: /*#__PURE__*/variables.size(300).reference,
      textStyle: 'body300WithCapsize',
      '[data-icon-before] &': {
        pl: '500'
      },
      '[data-icon-after] &': {
        pr: '500'
      },
      paddingX: '200',
      '& ~ .placeholder': /*#__PURE__*/_defineProperty({
        paddingX: '200'
      }, $labelOffset.variable, 'space.200')
    }
  }
};
var focus = {
  background: 'neutral.0',
  outlineColor: 'neutral.900',
  outlineWidth: '2px',
  _invalid: {
    outlineColor: 'danger.base'
  }
};
var element = {
  '&.icon-before': {
    pl: '100'
  },
  '&.icon-after': {
    pr: '100'
  },
  '&.icon': {
    color: 'neutral.500',
    pointerEvents: 'none',
    svg: {
      color: 'inherit'
    }
  }
};

/**
 * Common styles for input fields like `TextInput` and `Select`.
 *
 * @remarks The `.placeholder` selector targets the faux placeholder we render
 * in `Select`
 */
var field = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({
  appearance: 'none',
  background: 'neutral.50',
  border: '1px solid transparent',
  outline: '2px solid transparent',
  outlineOffset: '-2px',
  borderColor: 'transparent',
  boxSizing: 'border-box',
  color: 'neutral.text',
  fontFamily: 'body',
  minWidth: 0,
  position: 'relative'
}, /*#__PURE__*/transition.easing250('border', 'color', 'background', 'outline')), {}, /*#__PURE__*/_defineProperty({
  width: '100%',
  '&::placeholder, & ~ .placeholder': {
    color: 'neutral.300',
    opacity: 1,
    marginLeft: '-1px'
  },
  _invalid: {
    borderColor: 'danger.base'
  },
  _focus: focus,
  _focusWithin: focus,
  '&:hover:not([disabled]):not([data-invalid]):not(:focus)': {
    borderColor: 'neutral.900',
    _invalid: {
      borderColor: 'danger.base'
    }
  },
  _disabled: {
    background: 'neutral.200',
    borderColor: 'transparent',
    color: 'neutral.400',
    cursor: 'not-allowed',
    _placeholder: {
      color: 'neutral.400'
    },
    '& ~ div svg': {
      color: 'neutral.400'
    }
  },
  '&:focus ~ .icon': {
    color: 'neutral.800'
  },
  '& ~ .element-before': {
    justifyContent: 'start'
  },
  '& ~ .element-after': {
    justifyContent: 'end'
  }
}, $labelOffset.variable, 0), sizes["default"].field);
var easing250 = motion.easings[250];

/**
 * Variant for `TextInput` and `Select` when rendered within a `Field` and need
 * to display an "internal" label. The `label` element is rendered adjacent and
 * after the target input in that case, so we use the sibling (`~`) selector to
 * control the positioning and styling of the label based on the input's
 * `:focus` state, etc.
 */
var internalLabelVariant = function internalLabelVariant() {
  var emptySelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':placeholder-shown';
  return {
    field: _defineProperty(_defineProperty({
      _placeholder: _objectSpread2({
        opacity: 0
      }, transition.easing250('opacity')),
      _focus: {
        _placeholder: {
          opacity: 1
        }
      },
      paddingTop: $labelOffset.reference,
      '& ~ .icon-before': _objectSpread2(_objectSpread2({}, transition.easing250('top', 'height')), {}, {
        '& ~ label': {
          left: $labelLeft.reference
        }
      }),
      _disabled: {
        '& ~ label': {
          color: 'neutral.400'
        }
      },
      '& ~ label': {
        position: 'absolute',
        left: $focusLabelLeft.reference,
        top: '50%',
        pointerEvents: 'none',
        transform: 'translateY(-50%)',
        mb: '0 !important',
        transition: ["top ".concat(easing250), "left ".concat(easing250), "font-size ".concat(easing250), "line-height ".concat(easing250), "transform ease-in-out 175ms"].join(',')
      }
    }, "&:focus, &:not(".concat(emptySelector, ")"), {
      '& ~ label': {
        top: $focusLabelTop.reference,
        left: $focusLabelLeft.reference,
        transform: 'translateY(0%)'
      },
      '& ~ .icon-before': {
        top: $labelOffset.reference,
        height: calc.subtract('100%', $labelOffset.reference)
      }
    }), "&".concat(emptySelector, ":not(:focus):not([data-focus]) ~ label"), {
      fontSize: "".concat($labelFontSize.reference, " !important"),
      lineHeight: "".concat($labelLineHeight.reference, " !important")
    })
  };
};

var Input = {
  parts: ['addon', 'field', 'group', 'element'],
  defaultProps: {
    size: 'default'
  },
  baseStyle: {
    field: field,
    addon: {
      background: 'neutral.200',
      borderRadius: 300,
      border: 'idle'
    },
    element: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, element), {}, {
      svg: {
        color: 'neutral.500'
      }
    })
  },
  sizes: sizes,
  variants: {
    "default": {},
    'internal-label': /*#__PURE__*/internalLabelVariant()
  }
};

var Link = {
  defaultProps: {},
  baseStyle: function baseStyle(_ref) {
    var colorScheme = _ref.colorScheme,
      colors = _ref.theme.colors;
    return {
      alignItems: 'center',
      background: 'transparent',
      border: 'none',
      color: colorScheme === 'neutral' ? 'neutral.900' : colors.getStateColors(colorScheme).idle,
      display: 'inline-flex',
      outlineColor: 'transparent',
      fontFamily: 'body',
      _hover: {
        color: colorScheme === 'neutral' ? colors.alpha(0.18, 'neutral.900') : colors.getStateColors(colorScheme).hover
      },
      _focusVisible: {
        outlineWidth: '2px',
        outlineStyle: 'solid',
        outlineColor: 'neutral.900',
        outlineOffset: '2px'
      },
      transition: "\n        outline-color ".concat(motion.easings[250], "\n    ")
    };
  },
  sizes: sizes$3,
  variants: {
    underline: {},
    'persistent-underline': {},
    minimal: {}
  }
};

var internalLabel = /*#__PURE__*/internalLabelVariant('[data-empty]');
var Select = {
  defaultProps: {
    size: 'default',
    iconSize: '2em'
  },
  parts: ['field', 'icon'],
  baseStyle: {
    field: /*#__PURE__*/_mergeDeepRight(field, /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({
      cursor: 'pointer',
      _hover: {
        '& ~ .icon-after': {
          color: 'neutral.900'
        }
      }
    }, /*#__PURE__*/transition.easing250('border', 'background', 'outline')), {}, {
      '&[data-empty]': {
        color: 'transparent'
      },
      '&:not([data-empty])': {
        '& ~ .placeholder': {
          opacity: 0
        },
        color: 'neutral.900 !important'
      },
      '& ~ .placeholder': /*#__PURE__*/_objectSpread2({
        fontFamily: 'body',
        isTruncated: true,
        display: 'inline-flex',
        alignItems: 'center',
        paddingTop: $labelOffset.reference,
        opacity: 1,
        pointerEvents: 'none',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        '& > span': {
          isTruncated: true,
          marginRight: '-200'
        }
      }, /*#__PURE__*/transition.easing250('opacity'))
    }))
  },
  sizes: sizes,
  variants: {
    "default": {
      field: {
        '& ~ .placeholder': /*#__PURE__*/_defineProperty({}, $labelOffset.variable, 0)
      }
    },
    'internal-label': /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, internalLabel), {}, {
      field: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, internalLabel.field), {}, {
        '&:not(:focus) ~ .placeholder': {
          opacity: 0
        }
      })
    })
  }
};

var components$1 = {
  Badge: Badge,
  Accordion: Accordion,
  Button: Button,
  CloseButton: CloseButton,
  Form: Form,
  FormError: FormError,
  FormLabel: FormLabel,
  Icon: Icon,
  Input: Input,
  Link: Link,
  Select: Select,
  isNext: true,
  isBauhaus: true
};

var components = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, components$2), components$1);
var theme = /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({}, foundations), {}, {
  components: components
});

export { components, foundations, theme };
